import { ModuleFE_OpenTelemetry } from './ModuleFE_OpenTelemetry.js';
export const ModulePackFE_OpenTelemetry = [
    ModuleFE_OpenTelemetry
];
//# sourceMappingURL=module-pack.js.map